import request from '@/utils/request'

export function getPublicAdvertising(params = {}) {
  return request({
    url: `/ad_management/mp_ad_commons`,
    method: 'get',
    params
  })
}

export function getAccountAdvertising(params = {}) {
  return request({
    url: `/ad_management/mp_ad_commons`,
    method: 'get',
    params
  })
}

export function getAccountList(params = {}) {
  return request({
    url: `/ad_management/mp_ad_accounts`,
    method: 'get',
    params
  })
}
